import api from "./api";
import URLS from "../utils/urls.js";

export const getCustomerSites = () => {
  return api.get(URLS.BACKEND_API + `/customers/assets/sites`);
};
